// Saved sayfası: cihazdaki kayıtlılar (wd-saved) kanonik ürün kartıyla, en yeni önce.
// Kart sunucuda çizilir: /products/<handle>?section_id=product-card-view (trade fiyatı dahil).
// Kalpten çıkarılan kart listeden düşer; liste boşsa popüler tasarımlar görünür.

import { readList } from "walldora-thumbs";
import { api, decode, SITE_ROOT } from "walldora-studio";

const root = document.querySelector("[data-wd-saved]");
if (root) {
  init(root);
  initStudio(root);
  initWalls(root);
  initRenders(root);
  initPublished(root);
}

function readJson(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
}
function writeJson(key, value) {
  try {
    if (value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}

// From your studio: Studio'da kalple kaydedilenler (wd-saved-designs), en yeni önce. Oturum
// açmış müşteride önce hesaptaki liste gelir (components.js syncFavorites)
async function initStudio(root) {
  await Promise.race([window.wdFavoritesReady, new Promise((r) => setTimeout(r, 2500))]);
  const block = root.querySelector("[data-wd-saved-studio]");
  if (!block) return;
  const grid = block.querySelector("[data-wd-saved-studio-grid]");
  const template = block.querySelector("[data-wd-saved-studio-card]");
  // Format adları locale'den (data-f-<format>)
  const fmt = (f) => grid.dataset[`f${String(f).replace(/(^|-)([a-z])/g, (_, __, c) => c.toUpperCase())}`] || "";
  const list = (Array.isArray(readJson("wd-saved-designs")) ? readJson("wd-saved-designs") : []).slice().reverse();
  grid.replaceChildren(
    ...list.map((d) => {
      const node = template.content.firstElementChild.cloneNode(true);
      const link = node.querySelector("a");
      link.href = grid.dataset.base + encodeURIComponent(d.id);
      const img = node.querySelector("img");
      if (d.thumb) img.src = d.thumb;
      img.alt = `${fmt(d.format)} ${d.id}`.trim();
      node.querySelector(".wd-saved__design-id").textContent = d.id;
      node.querySelector(".wd-saved__design-format").textContent = fmt(d.format);
      const heart = node.querySelector("button");
      heart.setAttribute("aria-label", heart.dataset.label.replace("%id", d.id));
      heart.addEventListener("click", () => {
        // Hesaba da yazılır (components.js wdSaveDesign); cihazdan düşer
        if (window.wdSaveDesign?.has(d.id)) window.wdSaveDesign.toggle(d);
        else writeJson("wd-saved-designs", (readJson("wd-saved-designs") || []).filter((x) => x.id !== d.id));
        node.remove();
        block.hidden = grid.children.length === 0;
      });
      return node;
    })
  );
  block.hidden = list.length === 0;
}

// My walls (DURUM S2-25): adlandırılmış duvarlar, hesapta. Ekle (yükle ve kaydet), adını değiştir,
// kaldır; Design my wall ve See it on my wall'a o duvarla git
const wallSize = (w) => {
  if (!w.wIn || !w.hIn) return "";
  const f = (n) => `${Math.floor(n / 12)}' ${Math.round(n % 12)}"`;
  return `${f(w.wIn)} × ${f(w.hIn)}`;
};

async function initWalls(root) {
  const block = root.querySelector("[data-wd-saved-walls]");
  if (!block) return;
  const grid = block.querySelector("[data-wd-walls-grid]");
  const addCard = grid.querySelector(".wd-wallcard--add");
  const template = block.querySelector("[data-wd-wall-card]");
  const input = block.querySelector("[data-wd-wall-file]");
  const count = block.querySelector("[data-wd-walls-count]");
  const { listWalls, updateWall, uploadWall, store, WALL_KEY } = await import("walldora-studio");
  let walls = await listWalls();
  window.wdMyWalls = walls;
  document.dispatchEvent(new CustomEvent("wd:walls", { detail: walls }));

  const card = (w) => {
    const node = template.content.firstElementChild.cloneNode(true);
    const img = node.querySelector("img");
    if (w.thumb) img.src = w.thumb;
    img.alt = w.name || "";
    const name = node.querySelector("[data-wd-wall-name]");
    name.value = w.name || "";
    const save = () => {
      if (name.value.trim() === (w.name || "")) return;
      w.name = name.value.trim();
      updateWall(w.id, { save: true, name: w.name }).catch(() => window.wdToast?.(block.dataset.error, { tone: "danger" }));
    };
    name.addEventListener("change", save);
    name.addEventListener("keydown", (e) => e.key === "Enter" && name.blur());
    node.querySelector("[data-wd-wall-size]").textContent = wallSize(w) || block.dataset.noSize;
    node.querySelector("[data-wd-wall-design]").href = block.dataset.studio + w.id;
    node.querySelector("[data-wd-wall-see]").href = block.dataset.see + w.id;
    node.querySelector("[data-wd-wall-remove]").addEventListener("click", async () => {
      try {
        await updateWall(w.id, { remove: true });
        walls = walls.filter((x) => x.id !== w.id);
        if (store.get(WALL_KEY)?.id === w.id) store.set(WALL_KEY, null);
        node.remove();
        paint();
      } catch {
        window.wdToast?.(block.dataset.error, { tone: "danger" });
      }
    });
    return node;
  };
  const paint = () => {
    grid.replaceChildren(...walls.map(card), addCard);
    count.textContent = walls.length ? String(walls.length) : "";
  };
  paint();

  block.querySelector("[data-wd-wall-add]").addEventListener("click", () => input.click());
  input.addEventListener("change", async () => {
    const file = input.files[0];
    input.value = "";
    if (!file) return;
    addCard.classList.add("is-loading");
    try {
      const w = await uploadWall(file, { save: true });
      if (!w.saved) throw new Error("full");
      walls = [{ ...w, name: "" }, ...walls];
      paint();
      grid.querySelector("[data-wd-wall-name]")?.focus();
    } catch (err) {
      window.wdToast?.(walls.length >= 12 ? block.dataset.full : block.dataset.error, { tone: "danger" });
    } finally {
      addCard.classList.remove("is-loading");
    }
  });
}

// On my walls (DURUM S2-26): See It önizlemeleri bir katalog, hangi duvarda olduğu yazar
async function initRenders(root) {
  const block = root.querySelector("[data-wd-saved-renders]");
  if (!block) return;
  const { api } = await import("walldora-studio");
  let renders = [];
  try {
    renders = (await api("/renders")).renders ?? [];
  } catch {}
  if (!renders.length) return;
  const walls = await new Promise((r) => (window.wdMyWalls ? r(window.wdMyWalls) : document.addEventListener("wd:walls", (e) => r(e.detail), { once: true })));
  const wallName = (id) => walls.find((w) => w.id === id)?.name;
  const grid = block.querySelector("[data-wd-renders-grid]");
  const template = block.querySelector("[data-wd-render-card]");
  const base = block.dataset.root || "/";
  // Karar anı: ürün sayfası o duvarın ölçüsüyle açılır (hesaplayıcı ?w=&h= okur); Studio
  // tasarımı sipariş paneli açık gelir (?order=1)
  const size = (r) => (r.wIn && r.hIn ? `w=${Math.round(r.wIn)}&h=${Math.round(r.hIn)}` : "");
  const hrefOf = (r) =>
    r.product
      ? `${base}products/${encodeURIComponent(r.product)}${size(r) ? `?${size(r)}` : ""}`
      : `${base}apps/studio?design=${encodeURIComponent(r.design)}&order=1${size(r) ? `&${size(r)}` : ""}`;
  const metaOf = (r) => {
    const name = wallName(r.wall);
    return [r.studio ? block.dataset.studio : "", name ? block.dataset.wallTemplate.replace("%wall", name) : "", wallSize(r)].filter(Boolean).join(" · ");
  };
  // Hepsi tek galeri: kartın görseli lightbox'ı o önizlemede açar, oklarla diğerleri
  const items = renders.map((r) => ({
    src: r.preview,
    width: r.width,
    height: r.height,
    alt: r.title,
    title: r.title,
    meta: metaOf(r),
    note: block.dataset.note,
    href: hrefOf(r),
    cta: block.dataset.cta,
  }));
  const labels = { prev: block.dataset.prev, next: block.dataset.next, close: block.dataset.close };
  grid.replaceChildren(
    ...renders.map((r, k) => {
      const node = template.content.firstElementChild.cloneNode(true);
      const img = node.querySelector("img");
      img.src = r.thumb;
      img.alt = r.title;
      node.querySelector(".wd-rendercard__title").textContent = r.title;
      node.querySelector(".wd-rendercard__meta").textContent = metaOf(r);
      node.querySelector(".wd-rendercard__go").href = hrefOf(r);
      node.querySelector("[data-wd-render-open]").addEventListener("click", () => window.wdLightbox?.({ items, index: k, labels }));
      return node;
    })
  );
  block.querySelector("[data-wd-renders-count]").textContent = String(renders.length);
  block.hidden = false;
}

async function init(root) {
  // Oturum açmış müşteride önce hesaptaki liste gelsin (components.js), en fazla 2,5 sn
  await Promise.race([window.wdFavoritesReady, new Promise((r) => setTimeout(r, 2500))]);
  const base = root.dataset.root || "/";
  const grid = root.querySelector("[data-wd-saved-grid]");
  const empty = root.querySelector("[data-wd-saved-empty]");
  const popular = root.querySelector("[data-wd-saved-popular]");
  const count = root.querySelector("[data-wd-saved-count]");
  const handles = [...readList("wd-saved")].reverse().slice(0, 60);

  // Boş durum yalnız hiçbir şey kayıtlı değilse: Studio'dan kaydedilenler de sayılır
  const studio = root.querySelector("[data-wd-saved-studio-grid]");
  const sync = () => {
    const n = grid.children.length;
    const any = n + (studio?.children.length ?? 0) > 0;
    empty.hidden = any;
    if (popular) popular.hidden = any;
    // Katalogdan kayıt yok ama Studio'dan var: boş "Designs" başlığı kalmasın
    grid.closest(".wd-page__block").hidden = n === 0 && any;
    count.textContent = n > 0 ? String(n) : "";
  };

  // Yüklenirken kart iskeletleri
  grid.replaceChildren(
    ...handles.map(() => {
      const s = document.createElement("div");
      s.className = "wd-skeleton wd-skeleton--media";
      return s;
    })
  );

  const cards = await Promise.all(
    handles.map((handle) =>
      fetch(`${base}products/${encodeURIComponent(handle)}?section_id=product-card-view`)
        .then((r) => (r.ok ? r.text() : ""))
        .then((html) => new DOMParser().parseFromString(html, "text/html").querySelector(".wd-card"))
        .catch(() => null)
    )
  );
  grid.replaceChildren(...cards.filter(Boolean));
  grid.querySelectorAll("[data-wd-save]").forEach((b) => b.setAttribute("aria-pressed", "true"));
  showSavedSizes(root, grid);
  grid.removeAttribute("aria-busy");
  sync();

  // components.js kalbi çevirir; kayıttan çıkan kart listeden düşer
  grid.addEventListener("click", (event) => {
    const button = event.target.closest("[data-wd-save]");
    if (!button) return;
    requestAnimationFrame(() => {
      if (button.getAttribute("aria-pressed") === "false") {
        button.closest(".wd-card")?.remove();
        sync();
      }
    });
  });
}

// PDP'de "Save this size" ile kaydedilenler (wd-saved-sizes): kartın altında ölçü ve malzeme,
// kart ürüne o ölçü ve malzemeyle açılır (?variant=&w=&h=, hesaplayıcı okur)
function showSavedSizes(root, grid) {
  const sizes = readJson("wd-saved-sizes") || {};
  const ftIn = (inches) => {
    const r = Math.round(inches);
    return `${Math.floor(r / 12)}' ${r % 12}"`;
  };
  grid.querySelectorAll(".wd-card").forEach((card) => {
    const link = card.querySelector(".wd-card__link");
    const handle = link?.getAttribute("href")?.split("/products/")[1]?.split(/[?#]/)[0];
    const entry = handle && sizes[decodeURIComponent(handle)];
    if (!entry) return;
    const url = new URL(link.href, location.origin);
    url.searchParams.set("variant", entry.variant);
    url.searchParams.set("w", Math.round(entry.w));
    url.searchParams.set("h", Math.round(entry.h));
    link.href = url.pathname + url.search;
    const size = entry.size || `${ftIn(entry.w)} × ${ftIn(entry.h)}`;
    const line = document.createElement("span");
    line.className = "wd-card__saved-size";
    line.textContent = root.dataset.yourSize.replace("%size", entry.material ? `${size} · ${entry.material}` : size);
    card.querySelector(".wd-card__body")?.append(line);
  });
}

// Published: Studio'dan yayına gönderilenler, durumlarıyla (backend /apps/studio/api/published)
async function initPublished(root) {
  const block = root.querySelector("[data-wd-saved-published]");
  if (!block) return;
  const list = block.querySelector("[data-wd-published-list]");
  const template = block.querySelector("[data-wd-published-row]");
  const t = decode(JSON.parse(block.querySelector("[data-wd-published-i18n]").textContent));
  let entries = [];
  try {
    entries = (await api("/published")).entries ?? [];
  } catch {
    return;
  }
  const studio = (id) => `${SITE_ROOT}apps/studio?design=${encodeURIComponent(id)}`;
  list.replaceChildren(
    ...entries.map((e) => {
      const row = template.content.firstElementChild.cloneNode(true);
      const img = row.querySelector("img");
      if (e.thumb) img.src = e.thumb;
      row.querySelector(".wd-saved__pub-title").textContent = e.title;
      const chip = row.querySelector(".wd-status-chip");
      chip.dataset.status = e.status;
      chip.textContent = t.status[e.status] || "";
      row.querySelector(".wd-saved__pub-note").textContent = t.note[e.status] || "";
      const act = (name) => row.querySelector(`[data-act="${name}"]`);
      act("open").href = studio(e.id);
      act("share").hidden = e.status !== "published";
      act("unpublish").hidden = e.status === "rejected";
      act("why").hidden = e.status !== "rejected";
      act("share").addEventListener("click", async () => {
        const url = new URL(studio(e.id), location.origin).toString();
        try {
          if (navigator.share) await navigator.share({ title: e.title, url });
          else {
            await navigator.clipboard.writeText(url);
            window.wdToast?.(t.copied);
          }
        } catch {}
      });
      act("unpublish").addEventListener("click", async () => {
        try {
          const r = await api("/unpublish", { method: "POST", body: { id: e.id } });
          if (r.ok) row.remove();
          block.hidden = list.children.length === 0;
        } catch {
          window.wdToast?.(document.documentElement.dataset.wdToastError, { tone: "danger" });
        }
      });
      act("why").addEventListener("click", () => {
        const why = row.querySelector(".wd-saved__pub-why");
        why.textContent = e.reason || t.why_default;
        why.hidden = !why.hidden;
      });
      return row;
    })
  );
  block.hidden = entries.length === 0;
  if (location.hash === "#published" && entries.length) block.scrollIntoView();
}
